<template>
    <div class="customer-account">
        <div class="header-wrapper" id="header-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <h1>Hallo{{ displayFirstName ? ' ' + displayFirstName : '' }},</h1>
                        <p>Hier vind je jouw accountgegevens.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container container-wrapper">
            <div class="row">
                <div class="col-md-3">
                    <aut-customer-submenu :items="menuItems"></aut-customer-submenu>
                </div>
                <div class="col-md-9">
                    <div class="account-header">
                        <h2 class="account-header__title">Accountgegevens</h2>
                        <p class="account-header__subtitle">Overzicht van je bestellingen</p>
                    </div>

                    <div v-if="loading" class="account-loading">Laden...</div>

                    <div v-else-if="userData" class="account-cards">
                        <section class="account-card">
                            <div class="account-card__body">
                                <div class="account-card__title-row">
                                    <svg class="account-card__icon" width="24" height="24" viewBox="0 0 24 24" fill="#033239" aria-hidden="true">
                                        <mask id="mask0_5003_10801" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                            <rect width="24" height="24" fill="#D9D9D9"/>
                                        </mask>
                                        <g mask="url(#mask0_5003_10801)">
                                            <path d="M9.99997 11.6923C9.03461 11.6923 8.20993 11.3503 7.52595 10.6663C6.84198 9.98236 6.5 9.15769 6.5 8.19233C6.5 7.22694 6.84198 6.40227 7.52595 5.7183C8.20993 5.03434 9.03461 4.69235 9.99997 4.69235C10.9653 4.69235 11.79 5.03434 12.474 5.7183C13.158 6.40227 13.5 7.22694 13.5 8.19233C13.5 9.15769 13.158 9.98236 12.474 10.6663C11.79 11.3503 10.9653 11.6923 9.99997 11.6923ZM2.5 17.7885V17.0846C2.5 16.5795 2.62885 16.1221 2.88655 15.7125C3.14423 15.3029 3.50384 14.9859 3.96537 14.7616C4.79616 14.3475 5.69359 14.0016 6.65768 13.7241C7.62178 13.4465 8.73587 13.3077 9.99997 13.3077H10.2923C10.373 13.3077 10.4602 13.318 10.5538 13.3385C10.4525 13.5744 10.3689 13.8148 10.3028 14.0596C10.2368 14.3045 10.182 14.5538 10.1385 14.8077H9.99997C8.84869 14.8077 7.82947 14.9401 6.9423 15.2048C6.05512 15.4695 5.29229 15.7679 4.65383 16.1C4.42691 16.2218 4.2612 16.3641 4.1567 16.5269C4.05222 16.6897 3.99998 16.8756 3.99998 17.0846V17.8077H10.3C10.3743 18.0615 10.4708 18.3192 10.5894 18.5807C10.708 18.8423 10.8384 19.0846 10.9807 19.3077H4.0192C3.59742 19.3077 3.23878 19.1599 2.94328 18.8644C2.64776 18.5689 2.5 18.2102 2.5 17.7885ZM16.0038 19.4692L15.8827 18.7211C15.6442 18.6506 15.4199 18.5583 15.2096 18.4442C14.9993 18.3301 14.7993 18.1871 14.6096 18.0153L13.8653 18.2884C13.7064 18.3423 13.5532 18.3387 13.4058 18.2778C13.2583 18.2169 13.1423 18.1205 13.0577 17.9884L12.925 17.7538C12.8404 17.6115 12.8099 17.4557 12.8336 17.2865C12.8574 17.1173 12.9353 16.9801 13.0673 16.875L13.6654 16.4C13.5936 16.141 13.5577 15.8859 13.5577 15.6346C13.5577 15.3833 13.5936 15.1282 13.6654 14.8692L13.0769 14.375C12.9449 14.2698 12.8654 14.1368 12.8385 13.9759C12.8115 13.815 12.8404 13.6635 12.925 13.5212L13.0731 13.2712C13.1577 13.1391 13.2727 13.0426 13.4183 12.9817C13.5638 12.9208 13.716 12.9173 13.875 12.9712L14.6096 13.2443C14.7929 13.0725 14.9913 12.9311 15.2048 12.8202C15.4183 12.7093 15.6442 12.6186 15.8827 12.5481L16.0038 11.7846C16.0346 11.6154 16.1134 11.4792 16.2404 11.376C16.3673 11.2728 16.5154 11.2212 16.6846 11.2212H16.95C17.1192 11.2212 17.2673 11.2753 17.3942 11.3837C17.5211 11.492 17.5999 11.6308 17.6307 11.8L17.7423 12.5481C17.9807 12.6186 18.2067 12.7119 18.4201 12.8279C18.6336 12.9439 18.832 13.093 19.0153 13.275L19.7192 13.0019C19.8884 12.9378 20.0493 12.9362 20.2019 12.9971C20.3544 13.058 20.473 13.1596 20.5576 13.3019L20.6999 13.5365C20.7845 13.6788 20.8134 13.833 20.7865 13.999C20.7595 14.165 20.6801 14.3006 20.548 14.4057L19.9595 14.9C20.0313 15.1384 20.0672 15.3884 20.0672 15.65C20.0672 15.9115 20.0313 16.1615 19.9595 16.4L20.5576 16.875C20.6897 16.9801 20.7676 17.1147 20.7913 17.2788C20.815 17.4429 20.7845 17.5961 20.6999 17.7384L20.5519 17.9884C20.4672 18.1205 20.3538 18.2169 20.2115 18.2778C20.0692 18.3387 19.9185 18.3423 19.7596 18.2884L19.0153 18.0153C18.8256 18.1871 18.6256 18.3301 18.4153 18.4442C18.2051 18.5583 17.9807 18.6506 17.7423 18.7211L17.6307 19.4846C17.5999 19.6538 17.5211 19.79 17.3942 19.8932C17.2673 19.9964 17.1192 20.048 16.95 20.048H16.6846C16.5154 20.048 16.3673 19.9938 16.2404 19.8855C16.1134 19.7772 16.0346 19.6384 16.0038 19.4692ZM16.8077 17.5384C17.332 17.5384 17.7804 17.3522 18.1529 16.9798C18.5253 16.6073 18.7115 16.159 18.7115 15.6346C18.7115 15.1102 18.5253 14.6618 18.1529 14.2894C17.7804 13.917 17.332 13.7308 16.8077 13.7308C16.2833 13.7308 15.8349 13.917 15.4625 14.2894C15.09 14.6618 14.9038 15.1102 14.9038 15.6346C14.9038 16.159 15.09 16.6073 15.4625 16.9798C15.8349 17.3522 16.2833 17.5384 16.8077 17.5384ZM9.99997 10.1923C10.55 10.1923 11.0208 9.99649 11.4125 9.60483C11.8041 9.21316 12 8.74233 12 8.19233C12 7.64233 11.8041 7.17149 11.4125 6.77983C11.0208 6.38816 10.55 6.19233 9.99997 6.19233C9.44997 6.19233 8.97914 6.38816 8.58747 6.77983C8.19581 7.17149 7.99997 7.64233 7.99997 8.19233C7.99997 8.74233 8.19581 9.21316 8.58747 9.60483C8.97914 9.99649 9.44997 10.1923 9.99997 10.1923Z" fill="#033239"/>
                                        </g>
                                    </svg>
                                    <h3 class="account-card__title">Persoonlijke gegevens</h3>
                                </div>

                                <div class="account-card__field">
                                    <span class="account-card__label">Naam</span>
                                    <span class="account-card__value">{{ fullName }}</span>
                                </div>

                                <div class="account-card__field" v-if="hasAddress">
                                    <span class="account-card__label">Adres</span>
                                    <span class="account-card__value">
                                        <template v-if="streetLine">{{ streetLine }}<br></template>
                                        <template v-if="cityLine">{{ cityLine }}</template>
                                    </span>
                                </div>

                                <div class="account-card__field" v-if="userData.Telefoon">
                                    <span class="account-card__label">Telefoonnummer</span>
                                    <span class="account-card__value">{{ userData.Telefoon }}</span>
                                </div>
                            </div>
                            <div class="account-card__divider"></div>
                            <div class="account-card__actions">
                                <button type="button" class="account-card__cta" @click="openEditCustomerModal">
                                    <span>Bewerken</span>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                        <path d="M5.25 3.5L8.75 7L5.25 10.5" stroke="#033239" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </section>

                        <section class="account-card">
                            <div class="account-card__body">
                                <div class="account-card__title-row">
                                    <svg class="account-card__icon" width="24" height="24" viewBox="0 0 24 24" fill="#033239" aria-hidden="true">
                                        <mask id="mask0_5169_2013" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                            <rect width="24" height="24" fill="#D9D9D9"/>
                                        </mask>
                                        <g mask="url(#mask0_5169_2013)">
                                            <path d="M2.4 21.2C1.74 21.2 1.175 20.965 0.705 20.495C0.235 20.025 0 19.46 0 18.8V4.4C0 3.74 0.235 3.175 0.705 2.705C1.175 2.235 1.74 2 2.4 2H21.6C22.26 2 22.825 2.235 23.295 2.705C23.765 3.175 24 3.74 24 4.4V18.8C24 19.46 23.765 20.025 23.295 20.495C22.825 20.965 22.26 21.2 21.6 21.2H2.4ZM12 12.8L2.4 6.8V18.8H21.6V6.8L12 12.8ZM12 10.4L21.6 4.4H2.4L12 10.4ZM2.4 6.8V4.4V18.8V6.8Z" fill="#033239"/>
                                        </g>
                                    </svg>
                                    <h3 class="account-card__title">E-mail</h3>
                                </div>

                                <div class="account-card__field" v-if="userData.Email">
                                    <span class="account-card__label">E-mailadres</span>
                                    <span class="account-card__value">{{ userData.Email }}</span>
                                </div>
                            </div>
                            <div class="account-card__divider"></div>
                            <div class="account-card__actions">
                                <button type="button" class="account-card__cta" @click.prevent="openEditEmailModal">
                                    <span>Bewerken</span>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                        <path d="M5.25 3.5L8.75 7L5.25 10.5" stroke="#033239" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </section>

                        <section class="account-card">
                            <div class="account-card__body">
                                <div class="account-card__title-row">
                                    <svg class="account-card__icon" width="24" height="24" viewBox="0 0 24 24" fill="#033239" aria-hidden="true">
                                        <path d="M2 21C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19V9C0 8.45 0.195833 7.97917 0.5875 7.5875C0.979167 7.19583 1.45 7 2 7H3V5C3 3.61667 3.4875 2.4375 4.4625 1.4625C5.4375 0.4875 6.61667 0 8 0C9.38333 0 10.5625 0.4875 11.5375 1.4625C12.5125 2.4375 13 3.61667 13 5V7H14C14.55 7 15.0208 7.19583 15.4125 7.5875C15.8042 7.97917 16 8.45 16 9V19C16 19.55 15.8042 20.0208 15.4125 20.4125C15.0208 20.8042 14.55 21 14 21H2ZM2 19H14V9H2V19ZM8 16C8.55 16 9.02083 15.8042 9.4125 15.4125C9.80417 15.0208 10 14.55 10 14C10 13.45 9.80417 12.9792 9.4125 12.5875C9.02083 12.1958 8.55 12 8 12C7.45 12 6.97917 12.1958 6.5875 12.5875C6.19583 12.9792 6 13.45 6 14C6 14.55 6.19583 15.0208 6.5875 15.4125C6.97917 15.8042 7.45 16 8 16ZM5 7H11V5C11 4.16667 10.7083 3.45833 10.125 2.875C9.54167 2.29167 8.83333 2 8 2C7.16667 2 6.45833 2.29167 5.875 2.875C5.29167 3.45833 5 4.16667 5 5V7Z" fill="#033239"/>
                                    </svg>
                                    <h3 class="account-card__title">Wachtwoord</h3>
                                </div>

                                <div class="account-card__field">
                                    <span class="account-card__label">Wachtwoord</span>
                                    <span class="account-card__value account-card__value--mono">************</span>
                                </div>
                            </div>
                            <div class="account-card__divider"></div>
                            <div class="account-card__actions">
                                <button type="button" class="account-card__cta" @click.prevent="openChangePasswordModal">
                                    <span>Bewerken</span>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                                        <path d="M5.25 3.5L8.75 7L5.25 10.5" stroke="#033239" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </section>
                    </div>

                    <div v-else class="account-empty">
                        Geen gegevens gevonden.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from './SubMenu';
import ChangePasswordModal from './ChangePasswordModal';
import EditCustomerModal from './EditCustomerModal';
import EditEmailModal from './EditEmailModal';

export default {
    name: 'Account',

    components: {
        'aut-customer-submenu': SubMenu,
        ChangePasswordModal,
        EditCustomerModal,
        EditEmailModal,
    },

    props: {
        firstName: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            loading: true,
            userData: null,
        };
    },

    computed: {
        menuItems() {
            return [
                { label: 'Mijn Autohopper', url: '/dashboard', active: false, icon: 'dashboard' },
                { label: 'Reserveringen', url: '/dashboard/reservations', active: false, icon: 'reservations' },
                { label: 'Accountgegevens', url: '/dashboard/account', active: true, icon: 'account' },
                { label: 'Uitloggen', url: '/user/logout', active: false, icon: 'logout' },
            ];
        },

        fullName() {
            if (!this.userData) return '';

            let title = this.userData.Titel || '';
            if (title.toLowerCase() === 'anders') {
                title = '';
            } else if (title.length > 0) {
                title = title.charAt(0).toUpperCase() + title.slice(1) + '.';
            }

            const parts = [title, this.userData.Voornaam, this.userData.Achternaam]
                .filter(part => part && String(part).trim() !== '');
            return parts.join(' ');
        },

        displayFirstName() {
            return (this.userData && this.userData.Voornaam) ? this.userData.Voornaam : this.firstName;
        },

        streetLine() {
            if (!this.userData) return '';
            return [this.userData.Straat, this.userData.Huisnummer]
                .filter(part => part && String(part).trim() !== '')
                .join(' ');
        },

        cityLine() {
            if (!this.userData) return '';
            return [this.userData.Postcode, this.userData.Stad]
                .filter(part => part && String(part).trim() !== '')
                .join(' ');
        },

        hasAddress() {
            return this.streetLine || this.cityLine;
        },
    },

    mounted() {
        this.fetchUserData();
    },

    methods: {
        fetchUserData() {
            this.loading = true;
            window.axios.get('/api/customer/mendix-user-data')
                .then(response => {
                    this.userData = response.data;
                    console.log(this.userData);
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetching user data:', error);
                    this.loading = false;
                });
        },

        openChangePasswordModal() {
            this.$modal.show(ChangePasswordModal, {
                classes: ['v-modal', 'small-modal']
            });
        },

        openEditCustomerModal() {
            this.$modal.show(EditCustomerModal, {
                props: {
                    userData: this.userData
                },
                classes: ['v-modal', 'no-scrollbar'],
                events: {
                    'data-updated': () => {
                        this.fetchUserData();
                    }
                }
            });
        },

        openEditEmailModal() {
            this.$modal.show(EditEmailModal, {
                props: {
                    userData: this.userData
                },
                classes: ['v-modal', 'small-modal'],
                events: {
                    'data-updated': () => {
                        this.fetchUserData();
                    }
                }
            });
        },
    },
};
</script>

<style scoped>
.customer-account {
    padding: 40px 0;
}

.header-wrapper {
    padding: 2rem 0;
}

.header-wrapper h1 {
    font-family: Montserrat, sans-serif;
    font-size: 2rem;
    font-style: normal;
    font-weight: 700;
    line-height: 3rem;
}

.header-wrapper p {
    font-family: Montserrat, sans-serif;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2rem;
}

.container-wrapper {
    padding-top: 2.5rem;
}

.account-header {
    margin-bottom: 1.5rem;
}

.account-header__title {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: normal;
    color: #033239;
    margin: 0 0 1rem 0;
}

.account-header__subtitle {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: #38383b;
    margin: 0;
}

.account-loading,
.account-empty {
    font-family: 'Montserrat', sans-serif;
    font-size: 1rem;
    color: #033239;
    padding: 1rem 0;
}

.account-cards {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.account-card {
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 8px 9px rgba(0, 125, 147, 0.13);
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: .8rem;
}

.account-card__body {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.account-card__title-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.account-card__icon {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
}

.account-card__title {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1.5rem;
    color: #033239;
    margin: 0;
}

.account-card__field {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.account-card__label {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 0.875rem;
    color: rgba(0, 171, 200, 0.85);
}

.account-card__value {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.375rem;
    color: #033239;
}

.account-card__value--mono {
    font-family: 'Inter', 'Montserrat', sans-serif;
    line-height: 1.5rem;
    letter-spacing: 1px;
}

.account-card__divider {
    height: 1px;
    background: #cdd6d7;
    width: 100%;
}

.account-card__actions {
    display: flex;
    justify-content: flex-end;
}

.account-card__cta {
    display: inline-flex;
    align-items: center;
    gap: .5rem;
    background: #82db39;
    border: 1px solid #82db39;
    color: #033239;
    padding: 1rem 1.5rem;
    border-radius: 4px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1rem;
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;
}

.account-card__cta:hover,
.account-card__cta:focus {
    background: #70c72e;
    border-color: #70c72e;
    color: #033239;
    text-decoration: none;
}

@media (max-width: 575px) {
    .account-card {
        padding: 1.5rem;
    }

    .account-card__actions {
        justify-content: stretch;
    }

    .account-card__cta {
        width: 100%;
        justify-content: center;
    }
}
</style>
